(ns app.front.view.phase-event.list
  (:require [app.front.entities :as entities]
            [app.front.ui.table :as ui-table]
            [app.front.view.phase-event.subs :as subs]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.user.model :as user-model]))

(defn- render-time
  [tz {:keys [time only-date?]}]
  (cond
    (nil? time) "-"
    only-date?  (date-util/date-in-tz time tz)
    :else       (date-util/date-time-in-tz time tz)))

(defn- render-event-name
  [tr {:keys [event]}]
  (tr [event]))

(defn- render-users
  [{:keys [users]}]
  (if (seq users)
    (let [entities (->> (-> (group-by int? users)
                            (update true (fn [ids]
                                           (when (seq ids)
                                             (<sub [::entities/entities (set ids)]))))
                            vals)
                        (mapcat identity))]
      (->> entities
           (map user-model/full-name)
           sort
           (str/join ", ")))
    "-"))

(defn- show-all-link
  [phase-id tr]
  (when (and (<sub [::subs/more-to-show? phase-id])
             (not (<sub [::subs/show-all? phase-id])))
    (cc/link
      {:on-click #(>evt [::subs/show-all-clicked phase-id])}
      (tr [:phase-event/show-all]
          [(<sub [::subs/event-count phase-id])]))))

(defn- event-table
  [phase-id tr]
  (let [tz (<sub [::ws-subs/group-time-zone])]
    [:<>
     [ui-table/modern-responsive-table
      {:cols       [[:phase-event/time
                     (partial render-time tz)]
                    [:phase-event/event
                     (partial render-event-name tr)]
                    [:phase-event/users
                     render-users]]
       :items      (<sub [::subs/visible-phase-events phase-id])
       :tr         tr
       :get-status :status
       :link       {:description (tr [:open])
                    :make-href   :href}
       :id-func    (fn [{:keys [event] :as item}]
                     (str (:db/id item) "-" (name event)))}]]))

(defn view
  [phase-id]
  (let [tr (<sub [::ws-subs/tr])]
    [:<>
     [event-table phase-id tr]
     [show-all-link phase-id tr]]))
